export default {
  title: 'พัสดุ',
  new_parcel: 'พัสดุใหม่',
  edit_parcel: 'แก้ไขพัสดุ',
  parcel_detail: 'รายละเอียดพัสดุ',

  labels: {
    tracking_number: 'หมายเลขติดตาม',
    carrier: 'ผู้จัดส่ง',
    description: 'รายละเอียด',
    status: 'สถานะ',
    property: 'อสังหาริมทรัพย์',
    customer: 'ผู้เช่า',
    recipient_name: 'ชื่อผู้รับ',
    recipient: 'ผู้รับ / ห้อง',
    unit: 'ห้อง',
    photos: 'รูปภาพ',
    received_at: 'วันที่รับ',
    notified_at: 'วันที่แจ้ง',
    collected_at: 'วันที่รับของ',
  },

  status: {
    pending: 'รอรับ',
    notified: 'แจ้งแล้ว',
    collected: 'รับแล้ว',
    needs_review: 'ต้องตรวจสอบ',
  },

  carriers: {
    thailand_post: 'ไปรษณีย์ไทย',
    kerry_express: 'Kerry Express',
    flash_express: 'Flash Express',
    jt_express: 'J&T Express',
    shopee_express: 'Shopee Express',
    lazada_express: 'Lazada Express',
    other: 'อื่นๆ',
  },

  actions: {
    notify_customer: 'แจ้งผู้เช่า',
    mark_collected: 'ยืนยันการรับของ',
    assign_unit: 'กำหนดห้อง',
  },

  placeholders: {
    tracking_number: 'เช่น TH123456789',
    carrier: 'เลือกผู้จัดส่ง',
    custom_carrier: 'ป้อนชื่อผู้จัดส่ง',
    description: 'รายละเอียดพัสดุ...',
    select_property: 'เลือกอสังหาริมทรัพย์',
    select_customer: 'เลือกผู้เช่า',
    recipient_name: 'เช่น สมชาย ใจดี',
    select_unit: 'เลือกห้อง',
  },

  messages: {
    created: 'ลงทะเบียนพัสดุแล้ว',
    updated: 'อัปเดตพัสดุแล้ว',
    deleted: 'ลบพัสดุแล้ว',
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบพัสดุนี้?',
    notified: 'แจ้งผู้เช่าแล้ว',
    collected: 'ยืนยันการรับของแล้ว',
  },

  empty: {
    title: 'ไม่มีพัสดุ',
    description: 'พัสดุที่ลงทะเบียนจะปรากฏที่นี่',
  },

  setup_guide: {
    title: 'เริ่มต้นใช้งานพัสดุ',
    description: 'ลงทะเบียนและติดตามพัสดุสำหรับผู้เช่าของคุณ',
    prerequisites: {
      customers: 'อสังหาริมทรัพย์อย่างน้อย 1 แห่งที่มีผู้เช่า',
    },
    steps: {
      register: {
        title: 'ลงทะเบียนพัสดุ',
        description: 'บันทึกพัสดุที่ได้รับพร้อมข้อมูลติดตาม',
      },
      notify: {
        title: 'แจ้งผู้เช่า',
        description: 'แจ้งให้ผู้เช่าทราบว่าพัสดุมาถึงแล้ว',
      },
      collect: {
        title: 'ยืนยันรับของ',
        description: 'บันทึกเมื่อผู้เช่ามารับพัสดุ',
      },
    },
  },

  filters: {
    all: 'ทั้งหมด',
    pending: 'รอรับ',
    notified: 'แจ้งแล้ว',
    collected: 'รับแล้ว',
    needs_review: 'ต้องตรวจสอบ',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    search_placeholder: 'ค้นหาเลขพัสดุ ชื่อผู้รับ ห้อง หรือผู้เช่า...',
  },

  timeline: {
    received: 'รับพัสดุแล้ว',
    notified: 'แจ้งผู้เช่าแล้ว',
    collected: 'ผู้เช่ารับของแล้ว',
  },

  extraction: {
    reading_unit: 'กำลังอ่านห้อง...',
    unit_matched: 'ตรวจพบห้อง {{number}}',
    confirm_unit: 'กรุณายืนยันห้อง',
    no_match: 'ไม่พบข้อมูลห้อง',
    photo_hint: 'เคล็ดลับ: ถ่ายภาพป้ายที่อยู่ให้ชัดเจนช่วยระบุห้องโดยอัตโนมัติ',
  },

  scan: {
    page_title: 'เพิ่มพัสดุด่วน',
    capture_prompt: 'แตะเพื่อถ่ายภาพป้ายที่อยู่',
    or_upload: 'หรืออัปโหลดจากคลัง',
    quick_add: 'เพิ่มด่วน',
    photo_preview: 'ภาพพัสดุ',
  },

  errors: {
    validation_failed: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแบบฟอร์มอีกครั้ง',

    fields: {
      property_id: 'อสังหาริมทรัพย์',
      customer_id: 'ผู้เช่า',
      unit_id: 'ห้อง',
      recipient_name: 'ชื่อผู้รับ',
      tracking_number: 'หมายเลขติดตาม',
      carrier: 'ผู้จัดส่ง',
      received_at: 'วันที่รับ',
    },

    codes: {
      blank: 'ต้องไม่เว้นว่าง',
      taken: 'ถูกใช้แล้ว',
      invalid: 'ไม่ถูกต้อง',
      too_short: 'สั้นเกินไป',
      too_long: 'ยาวเกินไป',
      inclusion: 'ค่าไม่อยู่ในรายการที่อนุญาต',
    },
  },
}
